import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Icon, Popover, Tooltip } from 'antd';
import { withTranslation, useTranslation } from 'react-i18next';
import {
  Container,
  BarContainer,
  IconButton,
  AccessibilityPopupWrapper,
  AccessibilityContent,
} from './style';
import { AccessibilitySvgIcon } from '../../images/svgIcons';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';
import { useDocumentContext } from '../../context/complexDocumentContext';
import { PageElementsContext } from '../../context/pageElementsContext';
import AccessibilitySummaryEditor from '../../containers/SidebarMenu/AccessibilitySummaryEditor';
import { ACCESSIBILITY_MODAL } from './translationValues';
import { BARCODE_ELEMENT, ELEMENT_TYPES } from '../../utils/complexDocumentConstants'

const NAMESPACES = ['ACCESSIBILITY_MODAL'];

const AccessibilityIcon = ({
  t,
  visible,
  setAccessibilityPopupVisible,
  elementUUID,
  staticTableBlock = false,
  dataElementType
}) => {
  const customCurrentBlockSelector = useCallback(store => store[CONTEXT_KEYS.CURRENT_BLOCK], []);
  const [currentEditingBlock] = useArtboardContext(customCurrentBlockSelector);

  const [, store] = useDocumentContext(() => null, `Accessibility`);

  const contextSelector = useCallback(store => store, []);
  const [documentContext] = useDocumentContext(contextSelector);

  const { updateComplexElementDetails } = useContext(PageElementsContext);

  const accessibilityInfo = staticTableBlock ? store.get()[elementUUID]?.style : store.get()[currentEditingBlock]?.contents.find(content => content.uuid === elementUUID)?.style;
  const updateAccessibleSummary = (summaryContent) => {
    updateComplexElementDetails(elementUUID, { summary: summaryContent.contents }, 'style');
  }

  return (
    <Container className="accessibility-icon">
      <BarContainer>
        <Popover
          visible={visible}
          content={
            <AccessibilityPopupWrapper>
              <p className="label">{t(ACCESSIBILITY_MODAL.SUMMARY_SCREEN_READER_LABEL.key, ACCESSIBILITY_MODAL.SUMMARY_SCREEN_READER_LABEL.value)}</p>
              <AccessibilityContent>
                <AccessibilitySummaryEditor
                  key={elementUUID}
                  itemUUID={`element-summary-${elementUUID}`}
                  contents={accessibilityInfo?.summary || ''}
                  customContainerStyle={{ marginTop: 10 }}
                  onSaveChanges={updateAccessibleSummary}
                  customizeHistory={false}
                  customClassName={'summary-editor'}
                />
              </AccessibilityContent>
            </AccessibilityPopupWrapper>
          }
          placement="rightTop"
        >
          <Tooltip placement="topLeft" title={t(ACCESSIBILITY_MODAL.ACCESSIBILITY_TOOLTIP.key, ACCESSIBILITY_MODAL.ACCESSIBILITY_TOOLTIP.value)}>
            {!visible ? (
              <IconButton onClick={() => setAccessibilityPopupVisible(true)}>
                <AccessibilitySvgIcon className="hover-icon" />
              </IconButton>
            ) : (
              <IconButton onClick={() => setAccessibilityPopupVisible(false)}>
                <Icon type="close" className="hover-icon close-icon" />
              </IconButton>
            )}
          </Tooltip> 
        </Popover>
      </BarContainer>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(AccessibilityIcon);